import PropTypes from 'prop-types';
import React from 'react';
import styles from './style.module.scss';
import cx from 'classnames';

class LoadingMessage extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    if(!this.props.visible){
      return null;
    }

    return (
      <div className={ cx(styles.container, this.props.className) }>
        <div className={ styles.inner }>
          <p>{ this.props.message }</p>
        </div>
      </div>
    );
  }
}

LoadingMessage.propTypes = {
  message: PropTypes.string,
  visible: PropTypes.bool
};

LoadingMessage.defaultProps = {
  message: "Loading...",
  visible: false
};

export default LoadingMessage;